import { render, staticRenderFns } from "./DataAdministrationContactRebuild.vue?vue&type=template&id=d83a640e&scoped=true"
import script from "./DataAdministrationContactRebuild.vue?vue&type=script&lang=js"
export * from "./DataAdministrationContactRebuild.vue?vue&type=script&lang=js"
import style0 from "./DataAdministrationContactRebuild.vue?vue&type=style&index=0&id=d83a640e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83a640e",
  null
  
)

export default component.exports